import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Label, Input } from './Bootstrap'

const CutFieldset = (props) => {
  return (
    <fieldset className={`cut_${props.index}`}>
      <Row>
        <Col>
          <div className="form-group">
            <Label htmlFor={`cuts[${props.index}][length]`}>
              Cut length
            </Label>
            <Input name={`cuts[${props.index}][length]`}
                   type="number"
                   onChange={props.calculateValues}
                   placeholder="Length (e.g. 2000)"
                   min={5}
                   max={50000}
                   required={true}
                   defaultValue={props.length}>
            </Input>
          </div>
        </Col>
        <Col>
          <div className="form-group">
            <Label htmlFor={`cuts[${props.index}][quantity]`}>
              Number required
            </Label>
            <Input type="number"
                   name={`cuts[${props.index}][quantity]`}
                   onChange={props.calculateValues}
                   placeholder="Quantity (e.g. 5)"
                   min={1}
                   max={200}
                   required={true}
                   defaultValue={props.quantity}>
            </Input>
          </div>
        </Col>
      </Row>

    </fieldset>
  )
}

CutFieldset.propTypes = {
  index: PropTypes.number,
  length: PropTypes.number,
  quantity: PropTypes.number
}

CutFieldset.defaultProps = {
  length: 1000,
  quantity: 1
}

export default CutFieldset;
